import WorkPermitIsPublished from "../../WorkPermitIsPublished/WorkPermitIsPublished";

export const PublishedRender = (params: any) => {
    return (
        <WorkPermitIsPublished isPublished={params?.row?.isPublished} />
    )
}
